import { useMemo, useState } from 'react';

import { splitArray } from 'utils/arrayHelpers';
import { LocaleOption } from '../common/types';
import { getLocaleLabel } from '../common/LocaleLabel/LocaleLabel';

const reorderLocales = (options: LocaleOption[], suffixValue: string) => {
  const [promoted, other] = splitArray(options, (opt) => opt.Suffix === suffixValue);
  return [...promoted, ...other];
};

export const localeFilterMatch = (localeOption: LocaleOption, query: string) => {
  const searchableString = getLocaleLabel(localeOption.data);
  return searchableString?.toLowerCase().includes(query?.toLowerCase().trim());
};

export const useFilterLocales = (localeOptions: LocaleOption[], priority: string) => {
  const [filter, setFilter] = useState('');

  const handleFilter = (query = '') => setFilter(query);

  const options = useMemo(() => {
    const reorderedLocales = reorderLocales(localeOptions, priority);

    return reorderedLocales.filter((option) => localeFilterMatch(option, filter));
  }, [filter, localeOptions, priority]);

  return {
    options,
    handleFilter,
  };
};
